<template>
  <div id="footer" class="acea-row row-middle">
    <router-link
      :to="item.url"
      class="item"
      :class="{ on: item.url === $route.path }"
      v-for="(item, index) in footerList"
      :key="index"
    >
      <!-- <div
        class="iconfont"
        :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"
      ></div> -->
	  <img style="width:25px;height: 25px;" :src="(item.url === $route.path ? item.icon2 : item.icon1)">
      <div>{{ item.name }}</div>
    </router-link>
  </div>
</template>
<script>
export default {
  name: "Footer",
  props: {},
  data: function() {
    return {
      footerList: [
        {
          name: "首页",
          // icon1: "icon-shouye-xianxing",
          // icon2: "icon-shouye",
		  icon1: "https://sz.daolongsz.com/static/foot_icon1.png",
		  icon2: "https://sz.daolongsz.com/static/foot_icon1_active.png",
          url: "/"
        },
		{
		  name: "查看报告",
		  // icon1: "icon-yingyongchengxu-xianxing",
		  // icon2: "icon-yingyongchengxu",
		  icon1: "https://sz.daolongsz.com/static/foot_icon3.png",
		  icon2: "https://sz.daolongsz.com/static/foot_icon3_active.png",
		  url: "/sizhu/history"
		},
		{
		  name: "分享海报",
		  // icon1: "icon-yingyongchengxu-xianxing",
		  // icon2: "icon-yingyongchengxu",
		  icon1: "https://sz.daolongsz.com/static/foot_icon6.jpg",
		  icon2: "https://sz.daolongsz.com/static/foot_icon6_active.jpg",
		  url: "/sizhu/poster"
		},
		// {
		//   name: "会员中心",
		//   // icon1: "icon-yingyongchengxu-xianxing",
		//   // icon2: "icon-yingyongchengxu",
		//   icon1: "https://sz.daolongsz.com/static/foot_icon5.png",
		//   icon2: "https://sz.daolongsz.com/static/foot_icon5_active.png",
		//   url: "/sizhu/qrcode"
		// },
        // {
        //   name: "分类",
        //   icon1: "icon-yingyongchengxu-xianxing",
        //   icon2: "icon-yingyongchengxu",
        //   url: "/category"
        // },
        // {
        //   name: "购物车",
        //   icon1: "icon-caigou-xianxing",
        //   icon2: "icon-caigou",
        //   url: "/cart"
        // },
        // {
        //   name: "我的",
        //   icon1: "icon-yonghu-xianxing",
        //   icon2: "icon-yonghu",
        //   url: "/user"
        // }
      ]
    };
  },
  methods: {}
};
</script>
